import axios from 'axios';
import xhrRoutes from './routes/xhr';
import Translator from './translator';
import stringifyObject from './../helpers/stringify-object';

export default function () {
  const follow = document.querySelector('.js-follow-element');
  const services = ['golfcourse', 'community', 'user', 'tournament'];
  const classWip = 'profile__link__follow--wip';

  if (!follow) {
    return false;
  }

  follow.addEventListener('click', function (e) {
    const service = follow.getAttribute('data-follow-service');
    const type = follow.getAttribute('data-follow-type');
    const followId = follow.getAttribute('data-follow-id');
    const privacy = follow.getAttribute('data-follow-privacy');
    const state = follow.getAttribute('data-follow-state');
    const route = xhrRoutes[service][type];

    if (
      !service
      || services.indexOf(service) === -1
      || !type
      || !followId
      || !route
      || follow.classList.contains(classWip)
    ) {
      return false;
    }

    follow.classList.add(classWip);
    route.params[route.params.service] = followId;

    axios.post(route.url, stringifyObject(route.params))
      .then((response) => {
        follow.classList.remove(classWip);
        showResponse(response, service, privacy, state);
      })
      .catch((error) => {
        follow.classList.remove(classWip);
        console.log(error);
      })
      .then(() => {
        // always executed
      });

    e.preventDefault();
  });

  /**
   * Show notification after the response
   *
   * @param type
   * @param message
   */
  function showNotification(type, message) {
    const notification = document.createElement('div');
    notification.classList.add('notification');
    notification.classList.add('notification--' + type);
    notification.innerHTML = message;
    document.body.appendChild(notification);
  }

  /**
   * Show response message
   *
   * @param response
   * @param service
   * @param privacy
   * @param state
   */
  function showResponse(response, service, privacy, state) {
    const followSpan = follow.querySelector('span');

    switch (response.data.data.state) {
      case 'not_following':
        follow.setAttribute('data-follow-type', 'follow');

        if (typeof privacy !== 'undefined' && privacy === 'private') {
          followSpan.innerHTML = Translator.trans('api.private.follow');

          if (state === 'follow') {
            showNotification('success', Translator.trans('api.' + service + '.message.not-following'));
          } else {
            showNotification('success', Translator.trans('api.' + service + '.message.private.not-following'));
          }
        } else {
          followSpan.innerHTML = Translator.trans(service === 'tournament' ? 'api.register' : 'api.follow');
          showNotification('success', Translator.trans('api.' + service + '.message.not-following'));
        }

        follow.setAttribute('data-follow-state', 'unfollow');
        break;
      case 'pending':
        followSpan.innerHTML = Translator.trans('api.pending');
        follow.setAttribute('data-follow-type', 'unfollow');
        showNotification('success', Translator.trans('api.' + service + '.message.pending'));

        follow.setAttribute('data-follow-state', 'pending');
        break;
      case 'following':
        followSpan.innerHTML = Translator.trans(service === 'tournament' ? 'api.unregister' : 'api.unfollow');
        follow.setAttribute('data-follow-type', 'unfollow');
        showNotification('success', Translator.trans('api.' + service + '.message.following'));

        follow.setAttribute('data-follow-state', 'follow');
        break;
      case 'fail':
        showNotification('error', Translator.trans('api.error.fail'));
        break;
      default:
        console.log('Unknown follow/unfollow response');
    }
  }
};
